import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const actionButton = css`
  block-size: ${spacing(7)};
`

export const wrapper = css`
  padding: ${spacing(1)};
  background-color: ${cssTheme.colors.absolute.white};
  border-start-start-radius: ${spacing(3)};
  border-start-end-radius: ${spacing(3)};
`
